import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import {
    GET_DETAILS_VISITOR_VISA_APPLICATION_ACTION_TYPE, GET_VISA_APPLICATION_ACTION_TYPE, GET_VISITOR_VISA_APPLIACTION_EXPORT_ACTION_TYPE, GET_VISITOR_VISA_APPLICATION_ACTION_TYPE, GET_VISITOR_VISA_INVITATION_ACTION_TYPE, UPDATE_VISITOR_VISA_APPROVAL_ACTION_TYPE, getDetailsVisitorVisaApplication, getDetailsVisitorVisaApplicationUrl, getVisitorVisaAppliacationExportUrl, getVisitorVisaApplicationUrl, getVisitorVisaInvitationUrl, headers, updateVisitorVisaApprovalUrl
    , getDelegateVisaInvitationUrl,
    getDelegateVisaApplicationUrl,
    getDetailsVisaApplicationDelegateUrl,
    updateDelegateVisaApprovalUrl,
    getDelegateVisaApplicationExportDataUrl
} from "../../../utils/constants";

export const getDelegateVisaInvitation_action = (companyName, status, exhibitorTypeId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            CompanyName: companyName,
            Status: status,
            ExhibitorTypeID: exhibitorTypeId,
        }
        console.log("getDelegateVisaInvitationUrl Action------->", params)

        const res = await axiosGet(getDelegateVisaInvitationUrl, params, headers)

        dispatch({
            type: GET_VISITOR_VISA_INVITATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateVisaApplication_action = (companyname) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            CompanyName: companyname,

        }
        console.log("getDelegateVisaApplicationUrl Action------->", params)

        const res = await axiosGet(getDelegateVisaApplicationUrl, params, headers)

        dispatch({
            type: GET_VISITOR_VISA_APPLICATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDetailsVisaApplicationDelegate_action = (id) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            DelegateRegistrationID: id,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),

        }
        console.log("getDetailsVisaApplicationDelegateUrl Action------->", params)

        const res = await axiosGet(getDetailsVisaApplicationDelegateUrl, params, headers)

        dispatch({
            type: GET_DETAILS_VISITOR_VISA_APPLICATION_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateDelegateVisaApproval_action = (isApproved, list) => async (dispatch) => {
    try {
        const mapData = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            Is_Approved: isApproved,
            approvalList: list
        }
        console.log("updateDelegateVisaApprovalUrl Action------->", mapData)

        const res = await axiosPost(updateDelegateVisaApprovalUrl, mapData, headers)

        dispatch({
            type: UPDATE_VISITOR_VISA_APPROVAL_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateVisaApplicationExportData_action = () => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getDelegateVisaApplicationExportDataUrl Action------->", params)

        const res = await axiosGet(getDelegateVisaApplicationExportDataUrl, params, headers)

        dispatch({
            type: GET_VISITOR_VISA_APPLIACTION_EXPORT_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}